import type {
  ActionSubjectType,
  SourceType,
  Task,
} from '@trello/atlassian-analytics';
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';

import type { Card as LegacyCardModel } from 'app/scripts/models/Card';

export function onTracedCardUpdate({
  card,
  traceId,
  taskName,
  source,
  field,
}: {
  card: LegacyCardModel;
  traceId: string;
  taskName: Task;
  source: SourceType;
  field: ActionSubjectType;
}) {
  return tracingCallback(
    {
      taskName,
      traceId,
      source,
    },
    () => {
      Analytics.sendUpdatedCardFieldEvent({
        field,
        source,
        containers: {
          card: { id: card.id },
          board: { id: card.get('idBoard') },
          list: { id: card.get('idList') },
        },
        attributes: {
          taskId: traceId,
        },
      });
    },
  );
}
